import moment from 'moment/moment';

export const indicatorsType = {
    fixed:'Унифицированные показатели',
    notFixed:'Неунифицированные показатели'
}

export const indicatorsActiveType = {
    active:'Действующие показатели',
    notActive:'Недействующие показатели'
}

export const divideDataForActive = (data) => {
    const result = data?.reduce((array, value) => {
        if (!array?.active) array['active'] = [];
        if (!array?.notActive) array['notActive'] = [];
        if (!!array.active && ((value?.startDate && !value?.endDate) || (!value?.fixedPcId) || (moment(value?.endDate) > moment())))
            array.active.push(value)
        else array.notActive.push(value)
        return array
    }, {})
    return {active: result?.active ?? [], notActive: result?.notActive ?? []}
}

export const divideNonFixedForActive = (data) => {
    return data?.reduce((dividedData, value) => {
        value.inactive && new Date().getFullYear() >= value.inactive ?
          dividedData.notActive.push(value) :
          dividedData.active.push(value)
        return dividedData
    }, {
        active: [],
        notActive: []
    })
}
